import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";

import React from "react";
import styled from "@emotion/styled";

import "./CustomDateFilter.css";

function CustomDateFilter(props) {
  // custom text field style for date filter
  const CustomTextField = styled(TextField)(() => ({
    "& label.Mui-focused": {
      color: "var(--primary-color)",
    },
    "& .MuiButtonBase-root": {
      color: "var(--primary-color)",
    },
    "& .MuiOutlinedInput-root": {
      color: "var(--primary-color)",
      backgroundColor: "white",
      "& fieldset": {
        borderColor: "var(--secondary-color)",
      },
      "&:hover fieldset": {
        borderColor: "var(--primary-color)",
        color: "var(--primary-color)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "var(--primary-color)",
      },
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      backgroundColor: "white",
      "&:focus": {
        borderRadius: 4,
        borderColor: "white",
      },
    },
  }));

  const getDisplayDate = (date) => {
    return date.toDateString().split(" ").slice(1, 3).join(" ");
  };

  let today = new Date();
  let thisWeekStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  while (thisWeekStart.getDay() !== 1) {
    thisWeekStart.setDate(thisWeekStart.getDate() - 1);
  }
  let previousWeekStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
  while (previousWeekStart.getDay() !== 1) {
    previousWeekStart.setDate(previousWeekStart.getDate() - 1);
  }
  let previousWeekEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  while (previousWeekEnd.getDay() !== 0) {
    previousWeekEnd.setDate(previousWeekEnd.getDate() - 1);
  }
  let monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
  let yearStart = new Date(today.getFullYear(), 0, 1);

  const presetRanges = [
    {
      value: "this_week",
      label: "This week",
      displayDate: getDisplayDate(thisWeekStart) + " - " + getDisplayDate(today),
    },
    {
      value: "last_week",
      label: "Last week",
      displayDate: getDisplayDate(previousWeekStart) + " - " + getDisplayDate(previousWeekEnd),
    },
    {
      value: "month",
      label: "This month",
      displayDate: getDisplayDate(monthStart) + " - " + getDisplayDate(today),
    },
    {
      value: "year",
      label: "This year",
      displayDate: getDisplayDate(yearStart) + " - " + getDisplayDate(today),
    },
  ];

  const listItemTextPrimary = (left, right) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="dark:text-white">{left}</div>
        <div
          style={{ color: "gray", display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          {right}
        </div>
      </div>
    );
  };

  return (
    // <Accordion disableGutters expanded = {props.expandedSetDate} onChange = {props.handleAccordionChange}>
    //   <AccordionSummary
    //       expandIcon = {<ExpandMore/>}
    //       sx = {styles.accordionSummary}
    //       >
    //       <div className='custom-date-accordion-summary-text'>Date Range</div>
    //   </AccordionSummary>
    //   <AccordionDetails sx = {styles.accordionDetails}>
    <List disablePadding dense sx={styles.list}>
      {/* render preset options */}
      {presetRanges.map((preset) => {
        return (
          <ListItem disablePadding key={preset.value}>
            <ListItemButton
              selected={props.rangeValue === preset.value}
              onClick={() => props.handleRangeChange(preset.value)}
            >
              <ListItemText primary={listItemTextPrimary(preset.label, preset.displayDate)} />
            </ListItemButton>
          </ListItem>
        );
      })}
      {/* followed by special case for custom */}
      <ListItem disablePadding key={"custom"}>
        <ListItemButton
          selected={props.rangeValue == "custom"}
          onClick={() => props.handleRangeChange("custom")}
        >
          <ListItemText
            primary={listItemTextPrimary(
              "Custom range",
              props.rangeValue != "custom" ? (
                <ExpandMore fontSize="smaller" />
              ) : (
                <ExpandLess fontSize="smaller" />
              )
            )}
          />
        </ListItemButton>
      </ListItem>
      {/* collapse is shown when Custom is selected, allowing users to select their custom dates*/}
      <Collapse in={props.rangeValue == "custom"}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="custom-date-pickers">
            <div className="custom-date-picker-container">
              <DesktopDatePicker
                label="Start Date"
                inputFormat="MM/DD/YYYY"
                value={props.startDate}
                onChange={props.handleStartDateChange}
                renderInput={(params) => <CustomTextField size="small" {...params} />}
              />
            </div>
            <div className="custom-date-picker-container">
              <DesktopDatePicker
                label="End Date"
                inputFormat="MM/DD/YYYY"
                value={props.endDate}
                onChange={props.handleEndDateChange}
                renderInput={(params) => <CustomTextField size="small" {...params} />}
              />
            </div>
          </div>
        </LocalizationProvider>
      </Collapse>
    </List>
    //   </AccordionDetails>
    // </Accordion>
  );
}

const styles = {
  accordionSummary: {
    backgroundColor: "var(--secondary-color)",
  },
  accordionDetails: {
    backgroundColor: "white",
    padding: "0 0px",
  },
  list: {
    width: "100%",
  },
};

export default CustomDateFilter;
